/* eslint-disable prettier/prettier */
/* prettier-ignore-file */

import { useState, useEffect, useCallback } from 'react';
import { roleService, Role } from '../services/roleService';

export const useRoles = () => {
	const [roles, setRoles] = useState<Role[]>([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const fetchRoles = useCallback(async () => {
		try {
			setLoading(true);
			setError(null);

			const data = await roleService.getAllRoles();
			setRoles(data);
		} catch (err: any) {
			setError(err.message);
		} finally {
			setLoading(false);
		}
	}, []);

	useEffect(() => {
		fetchRoles();
	}, [fetchRoles]);

	return {
		roles,
		loading,
		error,
		refetch: fetchRoles,
	};
};
